export const databoxDmsMessageAttachmentGridItemFrag = `
    id
    name
    type
    size
    path
`;
